export default __webpack_public_path__ + "assets/images/favicon/favicon-16x16.png";